import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TreeGroup } from '@rio-cloud/rio-uikit/Tree';

import type { AssetBookings } from '../../../domain/model/productInformation.types';
import type { AssetItem, GroupedAssets } from './types';

const name = 'data';

export type DataState = {
    trucks: AssetItem[];
    truckGroups: TreeGroup[];
    assetBookings?: AssetBookings;
    lastAssetHistoryFetchTime?: string;
};

const initialState: DataState = {
    trucks: [],
    truckGroups: [],
    lastAssetHistoryFetchTime: undefined,
};

const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers: {
        setFetchedGroupedAssets: (state: DataState, action: PayloadAction<GroupedAssets>): void => {
            state.trucks = action.payload.trucks;
            state.truckGroups = action.payload.truckGroups;
        },
        setLastAssetHistoryFetchTime: (state: DataState, action: PayloadAction<string>): void => {
            state.lastAssetHistoryFetchTime = action.payload;
        },
    },
});

export const dataActions = actions;
export const dataReducer = reducer;
